module.exports = __webpack_public_path__ + "static/media/53_A.233e4118.png";